import React, { PureComponent } from 'react';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get, post, put } from '../../redux/modules/interviews';
import FieldInput from '../../components/Field/Field';
import Editor from '../../components/editor/Editor';
import * as Validations from '../../validations/validations';

const FORM_NAME = 'PartnerForm';

class PartnerForm extends PureComponent {

  handlerSubmit(values = {}) {
    const { getAction, putAction, postAction, close } = this.props;
    const newData = { ...values };

    if (newData.id > 0) {
      return putAction(newData.id, newData)
        .then(() => {
          close();
          getAction();
        });
    }
    return postAction(newData).then(() => {
      close();
      getAction();
    });
  }

  render() {
    const { handleSubmit, pristine, reset, submitting } = this.props;
    return (
      <form
        className="planet-form notice-form"
        onSubmit={handleSubmit(this.handlerSubmit.bind(this))}>

        <div className="planet-form__container">
          <div className="row">
            <div className="col-md-4">
              <Field
                label="Video Url"
                name="video_url"
                validate={[Validations.required]}
                component={FieldInput}/>

              <Field
                label="Interview Url"
                name="url"
                validate={[Validations.required]}
                component={FieldInput}/>
            </div>
            <div style={{ margin: '0 13px' }}>
              <div className="row">
                <div className="col-md-12">
                  <Field
                    name="body"
                    validate={[Validations.required, Validations.minLength2, Validations.maxMediumText]}
                    component={Editor}/>
                </div>
              </div>
            </div>
            <div className="clearfix"></div>
            <div className="col-lg-12 text-right form-buttons">
              <button disabled={pristine || submitting} loading={submitting} type="submit"
                      className="btn  btn-primary btn-xl">Save
              </button>
              <button disabled={pristine || submitting} loading={submitting} type="button"
                      className="btn btn-primary btn-xl"
                      onClick={reset}>Clear
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

PartnerForm.propTypes = {};
PartnerForm.defaultProps = {};

PartnerForm = reduxForm({
  form: FORM_NAME
})(PartnerForm);

export default connect(
  (state, props) => {
    return {
      myValues: getFormValues(FORM_NAME)(state) || {},
      enableReinitialize: true,
      initialValues: props.defaultValues || {}
    };
  },
  (dispatch) => {
    return bindActionCreators({
      getAction: get,
      postAction: post,
      putAction: put
    }, dispatch);
  }
)(PartnerForm);



// WEBPACK FOOTER //
// ./src/forms/interview/index.js